module.exports = __webpack_public_path__ + "media/customizations/growfield/logo-5416993f7d84cfb776b502500368e76d.png";